import templateUrl from './home.html';
import Highcharts from 'highcharts';
require('highcharts/modules/map')(Highcharts);

export const homeComponent = {
    templateUrl,

    bindings: {
        details: '<'
    },

    controller: class HomeComponent {

        constructor(HomeService) {
            'ngInject';

            this.homeService = HomeService;
        }

        $onInit() {
            this.details = this.homeService.getHomeDetails(this.details);
            this.address = {};
            this.loadScript();
        }

        getDirections(address, type) {
            this.type = angular.copy(type);
            this.routeAddress = angular.copy(address);
        }

        loadScript() {
            let _script = document.createElement('script');
            _script.src = "https://secure.adnxs.com/px?id=1268134&t=1";
            _script.type = 'text/javascript';
            _script.async = false;
            _script.charset = 'utf-8';
            document.getElementsByTagName('head')[0].appendChild(_script);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/home/home.component.js